import * as React from 'react'
import { StoreProps } from '../../../../services/stores/casting.store'
import { I18nService } from '../../../../services/utils/i18n.service'
import { InfoBox } from '../casting-styled.component'

const i18nScoped = new I18nService(require('./casting-start-date-skip-waiting-order-hours-period.component.yml'))

export default function CastingStartDateSkipWaitingOrderHoursPeriodComponent ({ data: { editedCastingId, backofficeSkipsWaitingOrderHoursPeriod, backofficeAllowToStartInPast, offeredService }, store }: StoreProps) {
  if (window.currentUser?.type !== 'Operator' || backofficeSkipsWaitingOrderHoursPeriod || backofficeAllowToStartInPast || offeredService.waiting_order_hours_period <= 1) return null
  if (!editedCastingId) return null // currently, this option is only available when editing existing castings

  const actionLink = <a
    style={{ color: 'white', fontWeight: 'bold', textDecoration: 'underline' }}
    children={ i18nScoped.t('action', { count: offeredService.waiting_order_hours_period }) }
    onClick={ () => store.set({ backofficeSkipsWaitingOrderHoursPeriod: true }) } />

  return <InfoBox>{ i18nScoped.tFragment('message', { action: actionLink }) }</InfoBox>
}
